import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { Select } from "@ngxs/store";
import { Observable, of } from "rxjs";
import { filter, map } from "rxjs/operators";
import { AppState } from "src/app/app.state";
import { translateAndFormat } from "src/app/i18next";
import { Division } from "src/app/models/mir-rule.model";
import { isDefined } from "src/utils/isDefined/isDefined";
import { Option } from "../multi-select-dropdown/multi-select-dropdown.component";
@Component({
	selector: "app-division-filter",
	templateUrl: "./division-filter.component.html",
	styleUrls: ["./division-filter.component.scss"],
})
export class DivisionFilterComponent implements OnInit {
	constructor() {}
	@Select(AppState.selectDivisions) divisionsFromState$: Observable<Division[]>;
	@Output() divisionIds: EventEmitter<string[]> = new EventEmitter();
	divisions$: Observable<Option[]> = of([]);
	divisionLabel = translateAndFormat("division", "capitalize");

	ngOnInit(): void {
		this.divisions$ = this.divisionsFromState$.pipe(
			filter(isDefined),
			map(divisions => {
				return divisions.slice().map(div => {
					return {
						label: div.divisionName,
						value: div.divisionId,
					};
				});
			}),
		);
	}

	submitDropdownMultiSelect(ids: string[]) {
		this.divisionIds.emit(ids);
	}
}
